<script lang="ts" setup>
import { ref } from 'vue'
import { validate } from '@/helpers/util/quickValidate'

import type { ContactDetails } from '@repo/types/messageTypes'

import Icon from '../components/Icon.vue'
import { faLocationDot } from '@repo/icons/light/faLocationDot'
import { faPhone } from '@repo/icons/light/faPhone'
import { faEnvelope } from '@repo/icons/light/faEnvelope'
import { faUser } from '@repo/icons/light/faUser'
import { faUserTag } from '@repo/icons/light/faUserTag'

const emit = defineEmits(['submitForm'])

const complete = ref(false)

const triggerValidation = ref(false)

const formElement = ref<HTMLFormElement | null>(null)

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const phoneNumber = ref('')
const postcode = ref('')
const fields = [
  {
    // label: 'Name',
    name: 'firstName',
    icon: 'fa-user',
    // validations: { presence: { allowEmpty: false } },
    validations: ['presence'],
    valid: false,
    value: '',
    placeholder: 'First name',
    type: 'text',
    autocomplete: 'name',
    required: true,
  },
  {
    // label: 'Name',
    name: 'lastName',
    icon: 'fa-user-tag',
    // validations: { presence: { allowEmpty: false } },
    validations: ['presence'],
    valid: false,
    value: '',
    placeholder: 'Last name',
    type: 'text',
    autocomplete: 'name',
    required: true,
  },
  {
    // label: 'Email',
    name: 'email',
    icon: 'fa-envelope',
    // validations: { presence: { allowEmpty: false }, email: true },
    validations: ['presence', 'email'],
    valid: false,
    value: '',
    placeholder: 'Email',
    type: 'email',
    autocomplete: 'email',
    required: true,
  },
  {
    // label: 'Phone number',
    name: 'phone',
    icon: 'fa-phone',
    // validations: {
    //   presence: { allowEmpty: false },
    //   format: {
    //     pattern: 'phoneNumber',
    //     message: 'is not a valid phone number',
    //   },
    // },
    validations: ['presence', 'phonenumber'],
    valid: false,
    value: '',
    placeholder: 'Phone number',
    type: 'text',
    required: true,
  },
  {
    // label: 'Postcode',
    name: 'postcode',
    icon: 'fa-map-marker',
    // validations: {
    //   presence: { allowEmpty: false },
    //   format: { pattern: 'postcode', message: 'is not a valid postcode' },
    // },
    validations: ['presence', 'postcode'],
    valid: false,
    value: '',
    placeholder: 'Postcode',
    type: 'text',
    autocomplete: 'postal-code',
    required: true,
  },
]

function htmlValidate() {
  if (!formElement.value) {
    console.error('Form element is not defined')
    return false
  }

  const isValid = formElement.value.checkValidity()

  return isValid
}

function handleBlur() {
  const isValid = htmlValidate()

  if (isValid) {
    complete.value = true
  } else {
    complete.value = false
  }
}

function handleSubmitForm() {
  const submitFields: ContactDetails = {
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    phoneNumber: phoneNumber.value,
    postcode: postcode.value,
  }
  // Validate all inputs
  // this.triggerValidation = true
  // const form = formElement.value

  // if (!form) {
  //   console.error('Form element is not defined')
  //   return
  // }

  // const isValid = form.checkValidity()
  const isValid = htmlValidate()

  if (isValid) {
    emit('submitForm', submitFields)
  }

  // Emit submit event and pass fields with it
  // const complete = this.fields.every(field => field.valid === true)
  // if (complete) {
  //   this.$emit('submit', fields)
  // }
}

//   mounted() {
//     // Replace formats with matching regexes
//     // Set validation formats
//     // const format = get(this.field, 'validations.format.pattern')
//     // if (format) {
//     //   set(this.field, 'validations.format.pattern', formats[format])
//     // }
//   },
//   methods: {
//     // validate() {
//     //   if (this.field.validations) {
//     //     const validation = validate.single(
//     //       this.field.value,
//     //       this.field.validations
//     //     )
//     //     if (validation) {
//     //       this.valid = false
//     //       // Set field valid status to false to prevent submission after the removal of a valid value
//     //       this.field.valid = false
//     //       this.validationMessage = validation
//     //     } else {
//     //       this.valid = true
//     //       // Add valid flag to field
//     //       this.field.valid = true
//     //       // Emit completed event so we can check to see if form is valid after changes
//     //       this.$emit('completed')
//     //       // If auto is set, emit auto event so we can update/submit automatically
//     //       if (this.auto) {
//     //         this.$emit('auto-update')
//     //       }
//     //     }
//     //   }
//     // },
//     submitForm() {
//       const fields = {
//         name: this.name,
//         email: this.email,
//         phone: this.phone,
//         postcode: this.postcode,
//       }
//       // Validate all inputs
//       // this.triggerValidation = true
//       const form = this.$refs['request-quote-form'] as HTMLFormElement

//       const isValid = form.checkValidity()

//       if (isValid) {
//         this.$emit('submitForm', fields)
//       }

//       // Emit submit event and pass fields with it
//       // const complete = this.fields.every(field => field.valid === true)
//       // if (complete) {
//       //   this.$emit('submit', fields)
//       // }
//     },
//   },
// }
</script>

<template>
  <form
    ref="formElement"
    class="grid grid-cols-1 gap-2"
    @submit.prevent="handleSubmitForm"
  >
    <!-- 
        FIRST NAME
      -->
    <div class="group">
      <label
        for="firstName"
        class="mb-0 block text-sm/6 font-medium text-slate-600 group-has-user-valid:text-emerald-600 group-has-user-invalid:text-red-700 sr-only"
        >FirstName</label
      >
      <div class="grid grid-cols-1">
        <input
          id="firstName"
          v-model="firstName"
          autocomplete="given-name"
          class="col-start-1 row-start-1 mb-0 block w-full rounded-md border-transparent py-1.5 pl-10 text-base text-slate-500 outline-1 -outline-offset-1 outline-gray-300 transition placeholder:text-slate-400 user-valid:outline-emerald-500 focus:ring-0 focus:outline-1 focus:outline-brand-primary-500"
          placeholder="First name"
          required
          type="text"
          minlength="2"
          maxlength="50"
          @blur="handleBlur"
        />
        <span
          class="pointer-events-none col-start-1 row-start-1 ml-3 self-center justify-self-start text-slate-400"
        >
          <Icon
            class="fa-fw"
            :icon="faUser"
          />
        </span>
      </div>
      <p
        id="firstName-error"
        class="mt-2 hidden text-sm text-red-700 group-has-user-invalid:block"
      >
        Please enter your first name.
      </p>
    </div>

    <!-- 
        LAST NAME
      -->
    <div class="group">
      <label
        for="lastName"
        class="mb-0 block text-sm/6 font-medium text-slate-600 group-has-user-valid:text-emerald-600 group-has-user-invalid:text-red-700 sr-only"
        >LastName</label
      >
      <div class="grid grid-cols-1">
        <input
          id="lastName"
          v-model="lastName"
          autocomplete="family-name"
          class="col-start-1 row-start-1 mb-0 block w-full rounded-md border-transparent py-1.5 pl-10 text-base text-slate-500 outline-1 -outline-offset-1 outline-gray-300 transition placeholder:text-slate-400 user-valid:outline-emerald-500 focus:ring-0 focus:outline-1 focus:outline-brand-primary-500"
          placeholder="Last name"
          required
          type="text"
          minlength="2"
          maxlength="50"
          @blur="handleBlur"
        />
        <span
          class="pointer-events-none col-start-1 row-start-1 ml-3 self-center justify-self-start text-slate-400"
        >
          <Icon
            class="fa-fw"
            :icon="faUserTag"
          />
        </span>
      </div>
      <p
        id="lastName-error"
        class="mt-2 hidden text-sm text-red-700 group-has-user-invalid:block"
      >
        Please enter your last name.
      </p>
    </div>

    <!-- 
        Email
      -->
    <div class="group">
      <label
        for="email"
        class="mb-0 block text-sm/6 font-medium text-slate-600 group-has-user-valid:text-emerald-600 group-has-user-invalid:text-red-700 sr-only"
        >Email</label
      >
      <div class="grid grid-cols-1">
        <input
          id="email"
          v-model="email"
          autocomplete="email"
          class="col-start-1 row-start-1 mb-0 block w-full rounded-md border-transparent py-1.5 pl-10 text-base text-slate-500 outline-1 -outline-offset-1 outline-gray-300 transition placeholder:text-slate-400 user-valid:outline-emerald-500 focus:ring-0 focus:outline-1 focus:outline-brand-primary-500"
          placeholder="Email"
          required
          maxlength="254"
          type="email"
          @blur="handleBlur"
        />
        <span
          class="pointer-events-none col-start-1 row-start-1 ml-3 self-center justify-self-start text-slate-400"
        >
          <Icon
            class="fa-fw"
            :icon="faEnvelope"
          />
        </span>
      </div>
      <p
        id="email-error"
        class="mt-2 hidden text-sm text-red-700 group-has-user-invalid:block"
      >
        Please enter your email address.
      </p>
    </div>

    <!-- 
        Phone number
      -->
    <div class="group">
      <label
        for="phoneNumber"
        class="mb-0 block text-sm/6 font-medium text-slate-600 group-has-user-valid:text-emerald-600 group-has-user-invalid:text-red-700 sr-only"
        >Phone number</label
      >
      <div class="grid grid-cols-1">
        <input
          id="phoneNumber"
          v-model="phoneNumber"
          autocomplete="tel"
          class="col-start-1 row-start-1 mb-0 block w-full rounded-md border-transparent py-1.5 pl-10 text-base text-slate-500 outline-1 -outline-offset-1 outline-gray-300 transition placeholder:text-slate-400 user-valid:outline-emerald-500 focus:ring-0 focus:outline-1 focus:outline-brand-primary-500"
          placeholder="Phone number"
          pattern="^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$"
          required
          minLength="10"
          maxLength="15"
          type="tel"
          @blur="handleBlur"
        />
        <span
          class="pointer-events-none col-start-1 row-start-1 ml-3 self-center justify-self-start text-slate-400"
        >
          <Icon
            class="fa-fw"
            :icon="faPhone"
          />
        </span>
      </div>
      <p
        id="phoneNumber-error"
        class="mt-2 hidden text-sm text-red-700 group-has-user-invalid:block"
      >
        Please enter a valid phone number.
      </p>
    </div>

    <!-- 
        Postcode
      -->
    <div class="group">
      <label
        for="postcode"
        class="mb-0 block text-sm/6 font-medium text-slate-600 group-has-user-valid:text-emerald-600 group-has-user-invalid:text-red-700 sr-only"
        >Postcode</label
      >
      <div class="grid grid-cols-1">
        <input
          id="postcode"
          v-model="postcode"
          autocomplete="postal-code"
          class="col-start-1 row-start-1 mb-0 block w-full rounded-md border-transparent py-1.5 pl-10 text-base text-slate-500 outline-1 -outline-offset-1 outline-gray-300 transition placeholder:text-slate-400 user-valid:outline-emerald-500 focus:ring-0 focus:outline-1 focus:outline-brand-primary-500"
          placeholder="Postcode"
          required="true"
          type="text"
          maxlength="8"
          pattern="([A-PR-UWYZa-pr-uwyz]([A-HK-Ya-hk-y][0-9]([0-9]|[ABEHMNPRV-Yabehmnprv-y])?|[0-9]([0-9]|[A-HJKPSTUWa-hjkpstuw])?) ?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})"
          @blur="handleBlur"
        />
        <span
          class="pointer-events-none col-start-1 row-start-1 ml-3 self-center justify-self-start text-slate-400"
        >
          <Icon
            class="fa-fw"
            :icon="faLocationDot"
          />
        </span>
      </div>
      <p
        id="postcode-error"
        class="mt-2 hidden text-sm text-red-700 group-has-user-invalid:block"
      >
        Please enter a valid post code.
      </p>
    </div>

    <div
      class="level is-mobile"
      style="width: 100%"
    >
      <div
        class="control is-flex has-items-right"
        style="width: 100%"
      >
        <button
          class="button whitespace-wrap is-action is-fullwidth is-outlined disabled:hover:bg-white disabled:hover:text-action"
          :disabled="!complete"
          type="submit"
        >
          Get your instant quote
        </button>
      </div>
    </div>
  </form>
</template>
